import { Globe, BarChart3, ShieldCheck, Zap } from "lucide-react";

const benefits = [
  {
    icon: Globe,
    title: "100% Online",
    description: "Realiza tu solicitud desde cualquier lugar, sin necesidad de visitar una sucursal.",
  },
  {
    icon: BarChart3,
    title: "Compara opciones",
    description: "Evaluamos tu perfil con multiples entidades financieras para encontrar la mejor opcion.",
  },
  {
    icon: ShieldCheck,
    title: "Seguro y confidencial",
    description: "Tu informacion esta protegida con los mas altos estandares de seguridad.",
  },
  {
    icon: Zap,
    title: "Respuesta rapida",
    description: "Obtiene respuestas en el menor tiempo posible. Sujeto a evaluacion crediticia.",
  },
];

export default function BenefitsSection() {
  return (
    <section id="beneficios" data-testid="benefits-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600">
            Ventajas
          </span>
          <h2
            data-testid="benefits-title"
            className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Por que elegir CrediAcceso
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {benefits.map((b, i) => (
            <div
              key={b.title}
              data-testid={`benefit-card-${i}`}
              className="group bg-white rounded-3xl border border-slate-200/60 shadow-sm p-8 hover:-translate-y-1 hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-2xl bg-emerald-50 flex items-center justify-center mb-5 group-hover:bg-emerald-100 transition-colors duration-300">
                <b.icon className="w-5 h-5 text-emerald-600" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {b.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                {b.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
